import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import ValueRange from "../ui/inputs/ValueRange";

export default class PickPrice extends ComponentBase
{
  _valueRange: ValueRange;

  constructor(elem: ComponentElem)
  {
    super(elem);
    
    this._valueRange = <ValueRange>this.seekComponentByName("value-range");

    let $min = this.$root.find(".min"),
      $max = this.$root.find(".max");
    

    this._valueRange.emitter.on("update", (result)=>
    {
      // console.log(result);
    });
    

    this._valueRange.emitter.on("change", (result)=>
    {
      $min.text(result.min);
      $max.text(result.max);
    });
    
    this._valueRange.update(undefined, undefined, true);
    // this._valueRange.setRange(100, 1000);
  }
}